import { BrandTokens } from "../../../@tokens/BrandTokens";
import { GlobalTokens } from "../../../@tokens/GlobalTokens";
import { hexToRGB } from "../../../helpers/Colors/colors";

export const style: any = {
    theme: {
        color: BrandTokens.BrandColorPrimaryPure,
        fontSize: GlobalTokens.FontSizeXs,
        fontWeight: BrandTokens.FontWeightMedium,
        fontFamily: BrandTokens.FontFamily,
        lineHeight: GlobalTokens.LineHeightDefault,
        paddingBottom: GlobalTokens.SpacingSizeQuarck,
  
        underline: {
          height: GlobalTokens.BorderWidthThin,
        },
  
        icon: {
          paddingLeft: GlobalTokens.SpacingSizeNano
        },
  
        states: {
          hover: {
            icon: {
              transform: `translate(calc(${GlobalTokens.SpacingSizeXxxs} - ${GlobalTokens.SpacingSizeNano}))`
            }
          },
          focus: {
            outline: `${GlobalTokens.BorderWidthThin} auto ${BrandTokens.HighlightColorPure}`
          },
          disabled: {
            color: hexToRGB(BrandTokens.NeutralColorLowPure, GlobalTokens.OpacityLevelMedium)
          }
        },
  
        motion: {
            transitionDuration: GlobalTokens.MotionSwitchSlow?.TransitionDuration,
            transitionTimingFunction: GlobalTokens.MotionSwitchSlow?.TransitionTimingFunction
        },
      }
}